import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router";
import Loading from "@components/Statuses/Loading";
import Fail from "@components/Statuses/Fail";

const HomePage = lazy(() => import("@pages/HomePage"));

function Router() {
    class ErrorBoundary extends React.Component {
        constructor(props) {
          super(props);
          this.state = { hasError: false, error: "", errorInfo: "" };
        }
      
        static getDerivedStateFromError(error) {
          return { hasError: true };
        }
      
        componentDidCatch(error, errorInfo) {
          this.setState({ error: error, errorInfo: errorInfo })
        }
      
        render() {
          if (this.state.hasError) {
            return <div className="error-boundary">
                <Fail>
                  <h2>Something went wrong.</h2>
                  <p dangerouslySetInnerHTML={{ __html: (this.state.error) }}></p>
                  {/* <p dangerouslySetInnerHTML={{ __html: (this.state.errorInfo?.componentStack)?.replaceAll("\n", "<br/>") }}></p> */}
                  <p><strong>Path:</strong> {document.location.href}</p>
                  <p><strong>UserAgent:</strong> {navigator.userAgent}</p>
                  <p><strong>App version ID:</strong> {import.meta.env.VITE_COMMIT_ID}</p>
                </Fail>
            </div>
          }
      
          return this.props.children; 
        }
    }

    return (
        <ErrorBoundary>
          <Suspense fallback={<Loading fullScreen>
            <h1>Ładowanie...</h1>
          </Loading>}>
            <Routes>
                <Route path="*" element={<HomePage/>}/>
            </Routes>
          </Suspense>
        </ErrorBoundary>
    )
}

export default Router
